import styled from '@emotion/styled';
import { css } from '@emotion/react';

const TEMP_HARDCODED_COLOUR = '#322744';

export type BuyRentTabsWrapperProps = {
    includeHousePrices?: boolean;
};

export const BuyRentTabsWrapper = styled('div')<BuyRentTabsWrapperProps>(
    (props) => {
        const {
            theme: { borderRadius, mq, colors },
            includeHousePrices
        } = props;

        return css`
            width: 100%;
            height: 30px;
            background-color: ${colors.white};
            border-radius: ${borderRadius['4px']};
            border: 1px solid #d1d0cf;
            display: flex;

            ${mq.medium} {
                max-width: ${includeHousePrices ? `253px` : `153px`};
            }
        `;
    }
);

export type BuyRentTabProp = {
    isBold: boolean;
    width: string;
};

export const BuyRentTab = styled('button')<BuyRentTabProp>((props) => {
    const {
        theme: { borderRadius, colors, mq },
        width,
        isBold
    } = props;

    return css`
        width: 33.333%;
        border-radius: ${borderRadius['4px']};
        cursor: pointer;
        font-family: Lato, Helvetica, Arial, sans-serif;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 0;
        outline: none;
        background-color: ${isBold ? TEMP_HARDCODED_COLOUR : colors.white};
        color: ${isBold ? colors.white : colors['grey-steel']};

        ${mq.medium} {
            width: ${width};
        }
    `;
});
